import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MessageCircle } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-dark border-t border-accent/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Logo & About */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <img 
                src="/logo-final.png" 
                alt="Blue Team Village Logo" 
                className="w-10 h-10 object-contain"
              />
              <div>
                <h3 className="text-xl font-bold text-white font-mono">Blue Team Village Vizag Edition</h3>
              </div>
            </div>
            <p className="text-gray-400 text-sm">
              Empowering defenders with knowledge and resources to secure the digital world.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-accent font-mono text-lg mb-4">&gt; Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-accent transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/resources" className="text-gray-400 hover:text-accent transition-colors text-sm">
                  Resources
                </Link>
              </li>
              <li>
                <Link to="/challenges" className="text-gray-400 hover:text-accent transition-colors text-sm">
                  Challenges
                </Link>
              </li>
              <li>
                <a href="#about" className="text-gray-400 hover:text-accent transition-colors text-sm">
                  About Us
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-accent font-mono text-lg mb-4">&gt; Connect</h4>
            <div className="space-y-3">
              <a
                href="mailto:hello@blueteamvillageatvizag.live"
                className="flex items-center space-x-2 text-gray-400 hover:text-accent transition-colors text-sm"
              >
                <Mail size={16} />
                <span>hello@blueteamvillageatvizag.live</span>
              </a>
              <a
                href="https://discord.gg/EYmWz5Cu"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center space-x-2 bg-accent hover:bg-accent-blue text-primary font-bold py-2 px-4 rounded-lg font-mono text-sm transition-all duration-300 transform hover:scale-105 mt-2"
              >
                <MessageCircle size={18} />
                <span>Join Discord</span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-accent/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-white text-sm font-mono font-bold">
              © {currentYear} Team Cerberus. All rights reserved.
            </p>
            <p className="text-white text-xs font-mono font-bold">
              Built with ❤️ by Team Cerberus | Powered by React
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
